import React from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import { SessionProvider } from './Components/SessionContext';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './State/store';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <SessionProvider>
          <App />
        </SessionProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
